import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let SingleChoice = class SingleChoice extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    console.log("item", value);
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
  // get questionnaireType() {
  //   return QuestionnaireEditModule.questionnaireType;
  // }
  get getColorForAnswer() {
    if (this.zItem.answered) {
      if (this.zItem.rightAnswer) {
        return "type_green";
      } else if (this.zItem.rightAnswer === null) {
        return "type_yellow";
      } else {
        return "red";
      }
    } else {
      return "c999";
    }
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], SingleChoice.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], SingleChoice.prototype, "zIndex", void 0);
__decorate([Prop({
  type: String,
  default: "QUESTIONNAIRE"
})], SingleChoice.prototype, "questionnaireType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], SingleChoice.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], SingleChoice.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], SingleChoice.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], SingleChoice.prototype, "dataChage", null);
SingleChoice = __decorate([Component({
  name: "singleChoice"
})], SingleChoice);
export default SingleChoice;